import React, { useState } from "react";
import { compose } from "redux";

import TextField from "@material-ui/core/TextField";

import ApiButton from "../../../shared/ui/Api.Button";
import CurrencyFormater from "../../../shared/ui/Currency.Input";

import { reportsConnector } from "../../../services/reports/connector";
import { currencyTag } from "../../../utilities/formaters";

const TaxReportsTransferTax = ({ currency, reports, transferTax }) => {
  const [TaxAmount, UpdateTaxAmount] = useState("");
  const [BankPaymentId, UpdateBankPaymentId] = useState("");

  const currencyTitle = currencyTag[currency];
  const currencyUnit = `[${currencyTitle}]`;

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-12">
          <h3>Transfer tax {currencyTitle}:</h3>
        </div>
      </div>
      <div>
        <CurrencyFormater
          id="Amount-field"
          label={"Amount " + currencyUnit}
          value={TaxAmount}
          onChange={(e) => UpdateTaxAmount(e.target.value)}
          fullWidth={false}
        />
        <br />
        <TextField
          size="small"
          variant="outlined"
          id="BankPaymentId-field"
          label="Bank payment id"
          value={BankPaymentId}
          onChange={(e) => UpdateBankPaymentId(e.target.value)}
          fullWidth={false}
        />
        <br />
        <ApiButton
          sending={reports.taxTransfer.sending}
          sent={reports.taxTransfer.sent}
          buttonLabel={"Transfer tax info"}
          onButtonClick={() => transferTax(TaxAmount, BankPaymentId, currency)}
        />
      </div>
    </React.Fragment>
  );
};

export default compose(reportsConnector)(TaxReportsTransferTax);
